import React, { useEffect, useState } from "react"
import { silentAuth } from "./src/utils/auth"


const SessionCheck = (props) => {
  const [loading, setLoading] = useState(true);

  const handleCheckSession = () => {
    setLoading(false);
  }

  useEffect(() => {
    silentAuth(handleCheckSession)
  }, [])

  return (
    loading === false && <>{props.children}</>
  )
}

export const wrapRootElement = ({ element }) => {
  return <SessionCheck>{element}</SessionCheck>
}